import { List, Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { LocalUndoMomentRecord } from "./LocalUndoMomentRecord";

export const LocalUndoStackRecord = Record({
  past: List(),
  present: LocalUndoMomentRecord(),
  future: List()
});

const data = {
  objects: {
    present: "LocalUndoMomentRecord"
  },
  collections: {
    past: "LocalUndoMomentRecord",
    future: "LocalUndoMomentRecord"
  }
};
createFromJS.registerCallback("LocalUndoStackRecord", createFromJS.createNestedCallback(LocalUndoStackRecord, data));
